import tracksApi from '@/utils/api-v2/tracks';
import SequenceEvaluation from '@/models/tracks/sequenceEvaluation';
import { getField, updateField } from 'vuex-map-fields';

export default {
    namespaced: true,
    state: () => ({
        sequenceEvaluationData: new SequenceEvaluation()
    }),
    getters: {
        getField,
        activeSequenceEvaluation: state => state.sequenceEvaluationData.id
    },
    mutations: {
        updateField,
        RESET_SEQUENCE_EVALUATION_DATA (state) {
            state.sequenceEvaluationData = new SequenceEvaluation();
        },
        SET_SEQUENCE_EVALUATION_DATA (state, payload) {
            const sequenceEvaluation = new SequenceEvaluation();
            sequenceEvaluation.parseData(payload);
            state.sequenceEvaluationData = sequenceEvaluation;
        }
    },
    actions: {
        getActiveSequenceEvaluation ({ commit, dispatch }, id) {
            return tracksApi.getSequenceEvaluation(id).then(({ data }) => {
                commit('RESET_SEQUENCE_EVALUATION_DATA');
                commit('SET_SEQUENCE_EVALUATION_DATA', data);
            });
        }
    }
};
